import React from "react";

import styles from "./Loading.module.css";

interface LoadingProps {}

const Loading: React.FC<LoadingProps> = () => {
  return (
    <div className={styles.loadingContainer} aria-label="loading-spinner">
      <div className={styles.flexbox}>
        <div className={styles.ldsRing}>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  );
};

export default Loading;
